import { useSearchParams } from "react-router-dom";
import { portfolioAnalysisPages } from "@app/const/route.const";
import { ModuleSimulatedForwardProbabilitiesReport } from "./ModuleSimulatedForwardProbabilitiesReport";

export const PdfPortfolioAnalysisSimulatedForwardProbabilitiesReportPage =
  () => {
    const [searchParams] = useSearchParams();

    const {
      portfolioGroupId,
      moduleId,
      data1Id,
      data2Id,
      isReal,
      isCompare,
      chartDateRange1,
      chartDateRange2,
    } =
      portfolioAnalysisPages.getPdfSimulatedForwardProbabilitiesReportParams(
        searchParams,
      );

    return (
      <ModuleSimulatedForwardProbabilitiesReport
        portfolioGroupId={portfolioGroupId}
        moduleId={moduleId}
        data1Id={data1Id}
        data2Id={data2Id}
        isReal={isReal}
        isCompare={isCompare}
        chartDateRange1={chartDateRange1}
        chartDateRange2={chartDateRange2}
        footer="Portfolio Analysis"
      />
    );
  };
